export default __webpack_public_path__ + "static/media/matti_s.88b6ab15.jpg";